import React from 'react';
import { ImageFallbackSmall } from '../../../../components/common/image-fallbacks/image-fallback-small/image-fallback-small';
import { ResizedImageContainer } from '../../../../components/common/resized-image/resized-image.container';
import audioImg from '../../../../components/media-assets/images/audio.svg?url';
import imageImg from '../../../../components/media-assets/images/image.svg?url';
import { MimeTypeBase } from '../../../../types/entities';
import { MediaAsset } from '../../../../types/media-assets';
import folderImg from '../../icons-common/regular-folder.svg?url';
import fileImg from './file.svg?url';
import videoImg from './play.svg?url';
import styles from './thumb.scss';

const getIconSrc = (file: MediaAsset): any => {
  if (file.isFolder) {
    return folderImg;
  }

  switch (file.mimeTypeParsed.type) {
    case MimeTypeBase.Video:
      return videoImg;
    case MimeTypeBase.Image:
      return imageImg;
    case MimeTypeBase.Audio:
      return audioImg;
    default:
      return fileImg;
  }
};

const THUMB_WIDTH = 24;
const THUMB_HEIGHT = 24;

export interface ThumbProps {
  mediaAsset: MediaAsset;
}

export const Thumb = ({ mediaAsset }: ThumbProps) => {
  if (mediaAsset.mimeTypeParsed.type === MimeTypeBase.Image) {
    return (
      <div
        style={{ width: THUMB_WIDTH, height: THUMB_HEIGHT }}
        className={styles.wrapper}
      >
        <div className={styles.roundedFrame}>
          <ResizedImageContainer
            file={mediaAsset}
            imageClassName={styles.thumbImage}
            width={THUMB_WIDTH}
            height={THUMB_HEIGHT}
            fallback={<ImageFallbackSmall />}
            draggable={false}
          />
        </div>
      </div>
    );
  }

  return <img src={getIconSrc(mediaAsset)} alt="file-icon" draggable={false} />;
};
